import React, { Component } from "react";

import { IShare } from "@formant/core/model/IShare";

import { appStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    share: IShare;
    onRevokeShare: (share: IShare) => void;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove share"
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { share, onRevokeShare } = this.props;
        const { message: shareMessage } = share;
        const message = (
            <p>
                Revoke share "{shareMessage}"? Shared observability links and
                FEMs associated with this share will no longer usable.
            </p>
        );
        appStore.setConfirm({
            title: "Revoke share",
            message,
            onOk: () => {
                onRevokeShare(share);
                appStore.setSnackbar("Share revoked");
            },
        });
    };
}
